/* eslint-disable */
import React, { Component } from 'react'
import ReadAxios from '../axiosComponent/readAxios'
import { Header, Image, Table, Segment } from 'semantic-ui-react'
import Loader from '../loadingComponent/Loader'
export default class VehicleDetailsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            rowItems: [],
            temp: [],
            update: false,
            search_value: '',
            loadingData: true,
            VehicleTypeItems: []
        }
    }

    componentDidUpdate(props) {
        // console.log(props, this.state.update)
        if (this.state.update) {
            this.setState({ update: false })
            this.getData()
        }
    }
    getData = () => {
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/vendor_onboarding/vendors/`, method: "get", transporterId: this.state.id
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    rowItems: res.data.resultSet[0]['vehicles'],
                    temp: res.data,
                    loadingData: false
                })
            }
        })
        ReadAxios({
            masterURL: `${process.env.REACT_APP_MAIN_URL}/masters/VehicleTypeMaster`, method: "post",
        }).then((res) => {
            if (res.status === 200) {
                this.setState({
                    VehicleTypeItems: res.data.resultSet,
                })
            }
        })
    }

    getVehicleTypeName = (vehicleType_id) => {
        return this.state.VehicleTypeItems.map((o, i) => {
            const { vehicleType, vehicleTypeId } = o
            if (vehicleTypeId == vehicleType_id) {
                return (
                    vehicleType
                )
            }
        })
    }

    componentDidMount() {
        this.getData()
    }
    updated = (data) => {
        if (data) {
            this.setState({ update: !this.state.update })
        }
    }

    renderTableData() {
        return this.state.rowItems.map((o, i) => {
            return (
                <Table.Row key={i}>
                    <Table.Cell>{o.vehicleNumber}</Table.Cell>
                    <Table.Cell>{this.getVehicleTypeName(o.vehicleTypeId)}</Table.Cell>
                    <Table.Cell>{o.vehicleDimensions}</Table.Cell>
                    <Table.Cell>{o.vehicleCapacity}</Table.Cell>
                    <Table.Cell>{o.vehicleGps}</Table.Cell>
                    <Table.Cell>{o.vehicleBaseLocation}</Table.Cell>
                </Table.Row>
            )
        })
    }
    render() {
        let columnDefs = [
            { headerName: 'Partner Company Name', field: 'transporterName', tooltipField: 'orderNo', enableRowGroup: true, enablePivot: true },
            { headerName: 'ID', field: 'transporterMasterId', hide: true, tooltipField: 'transporterMasterId', enableRowGroup: true, enablePivot: true },
            { headerName: 'Registration Date', field: 'source', tooltipField: 'source', enableRowGroup: true, enablePivot: true },
            { headerName: 'Partner Address', field: 'customer_name', tooltipField: 'customer_name', enableRowGroup: true, enablePivot: true },
            { headerName: 'City', field: 'address', tooltipField: 'address', enableRowGroup: true, enablePivot: true },
            { headerName: 'Date & Time', field: 'city', tooltipField: 'city', enableRowGroup: true, enablePivot: true },
            { headerName: 'Status', field: 'pincode', tooltipField: 'pincode', enableRowGroup: true, enablePivot: true },
            { headerName: 'Vehicle Details', field: 'sdate', cellRenderer: 'actionRenderer', suppressToolPanel: true },
            { headerName: 'Approve/Reject', field: 'edit', cellRenderer: 'approveRenderer', suppressToolPanel: true },
        ]
        let rowData = []
        return (
            <div>
                {this.state.rowItems.length > 0 ?
                    <Table striped className="m-3">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Vehicle Number</Table.HeaderCell>
                                <Table.HeaderCell>Vehicle Type</Table.HeaderCell>
                                <Table.HeaderCell>Dimensions (in FT)</Table.HeaderCell>
                                <Table.HeaderCell>Capacity (in MT)</Table.HeaderCell>
                                <Table.HeaderCell>GPS Partner</Table.HeaderCell>
                                <Table.HeaderCell>Base Location</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.renderTableData()}
                        </Table.Body>
                    </Table>
                    :
                    <Segment>
                        {this.state.loadingData == false ?
                            <center> <h6> Vehicle details not provided </h6></center>
                            : <Loader />}
                    </Segment>
                }
            </div>
        )
    }
}
